export default __webpack_public_path__ + "static/media/img-flyers.42a9b6fe.png";